export default "__VITE_ASSET__DT$BaOu0__"